import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PdfChangeRequestViewComponent } from './pdf-change-request-view.component';

const routes: Routes = [
  {
    path: '',
    component: PdfChangeRequestViewComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PdfChangeRequestViewRoutingModule { }
